module.exports = __webpack_public_path__ + "3f65c5924ae6c31db7c851762abe22c9.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1/public/history/fi-2006.png
// module id = 366
// module chunks = 0